import "./CreateNewItem.scss"
import {EditorItemType, handleAddNewItem, prepareEditorDefaultItem} from "../RaikoCustomEditor2";

export default function CreateNewItem(
    {
        location,
        value,
        setValue
    }
) {




    return (
        <div className={"baseCreateNewItemContainer"}>
            <div className={"createItemsContainer"}>
                <div className={"plus_icon plusIconContainer"}/>

                <div className={"selectIconsContainer sliderIcon-icon"}
                     onClick={_ => handleAddNewItem(value,setValue,EditorItemType.IMAGE_SLIDER,location)}/>
                <div className={"selectIconsContainer videoIcon-icon"}
                     onClick={_ => handleAddNewItem(value,setValue,EditorItemType.INTERNAL_VIDEO,location)}/>
                <div className={"selectIconsContainer soundIcon-icon"}
                     onClick={_ => handleAddNewItem(value,setValue,EditorItemType.INTERNAL_SOUND,location)}/>
                <div className={"selectIconsContainer pictureIcon-icon"}
                     onClick={_ => handleAddNewItem(value,setValue,EditorItemType.IMAGE,location)}/>
                <div className={"selectIconsContainer textEditorIcon-icon"}
                     onClick={_ => handleAddNewItem(value,setValue,EditorItemType.HTML,location)}/>
            </div>
        </div>
    )
}
